import React from 'react';
import * as Routes from 'modules/routes';
import I18n from 'modules/i18n';
import { BorderColors, CardType, Program, SectionType } from '@/types/api/LessonOverview';
import greenBookIcon from 'images/icons/book-green-outline.png';
import blueBookIcon from 'images/icons/book-blue-outline.png';
import ButtonWithTooltip from '@/components/shared/LessonOverview/Cards/ActionBar/ButtonWithTooltip';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';
import Card, { ActionBar, CardBody } from './Card';
import AssignButton from './AssignButton';

type ReadingCardProps = {
  bannerBorderColor: BorderColors,
  bannerLabel: CardType,
  children: ReactChildren,
  lessonId: number,
  linkLabel: string,
  readingPath: string,
  sections: SectionType[],
  stafferId?: number,
  program: Program,
  type: string,
};

const ReadingCard = ({
  bannerBorderColor, bannerLabel, children, lessonId,
  linkLabel, readingPath, sections, stafferId, program, type,
}: ReadingCardProps) => {
  const renderActionBar = () => (
    <ActionBar>
      <AssignButton
        className="tw-w-7 tw-h-7 tw-p-1.25 tw-flex tw-justify-center tw-items-center"
        initialValues={{
          modelType: 'sectionNotebook',
          modelsToAssign: sections.map(section => section.assignable.value),
        }}
        isAssigned={sections.some(section => section.isAssigned)}
        lessonId={lessonId}
        program={program}
        stafferId={stafferId}
      />

      <ButtonWithTooltip
        openInNewWindow
        ariaLabel="Print reading"
        className="tw-box-border tw-flex tw-justify-center tw-items-center tw-h-7 tw-w-7"
        link={Routes.pdf_shared_program_lesson_path(program.id, lessonId, {
          locale: I18n.locale,
        })}
        tooltipContent={I18n.t('print_text')}
      >
        <Icon icon="Print" size={16} />
      </ButtonWithTooltip>
    </ActionBar>
  );

  return (
    <Card
      bannerBorderColor={bannerBorderColor}
      label={bannerLabel}
      type={type}
    >
      <CardBody
        ariaLabel={linkLabel}
        iconSrc={bannerBorderColor === 'green' ? greenBookIcon : blueBookIcon}
        linkHref={readingPath}
        linkLabel={linkLabel}
      >
        {children}
      </CardBody>

      {stafferId && renderActionBar()}
    </Card>
  );
};

export default ReadingCard;
